<script setup lang="ts">

</script>
<template>
  <div>
    <button disabled class="disabled:opacity-50 mt-4 group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500">
      <slot name="label" />
    </button>
  </div>
</template>